<ng-container *ngIf="userFoods && user; else noInfo">
  <div class="title-list">
    <h2>Comidas del participante: {{ user.name }} <span *ngIf="user && user.lastname">{{ user.lastname }}</span></h2>
    <h2 style="margin-left: 3rem !important;">Total: {{ userFoods.length }}</h2>
  </div>

  <div class="container-fluid" style="margin-bottom: 1rem;">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="simple-container">
          <div class="master-container">

            <mat-card style="margin-bottom: 1rem;">
              <mat-card-content>
                <div class="goal-container">
                  <mat-icon svgIcon="targetSvg"></mat-icon> <p class="icon-label">Meta personal:</p>
                  <p>
                    {{ (user && user.goal) ? user.goal : '--' }}
                  </p>
                </div>
              </mat-card-content>
            </mat-card>

            <form [formGroup]="foodFormArray">
              <ng-container *ngFor="let element of userFoods; let i=index">
                <div class="row">
                  <div class="col-12 col-lg-6 preview-food-img">
                    <img id="foodImg{{ i }}" src="{{ element.imgURL }}" alt="">
                  </div>
                  <div class="col-12 col-lg-6">
                    <div *ngIf="element.date_reg && element.time_reg">
                      <p> <b>Fecha captura:</b> {{ element.date_reg}} {{ element.time_reg }}</p>
                    </div>

                    <ng-container [formGroupName]="i">
                      <div class="puntuacion-container">
                        <div class="row">
                          <div class="col-12" style="text-align: right;">
                            <button mat-raised-button class="btn btn-danger" (click)="deleteFood(element)"
                              matTooltip="Borrar comida">
                              <mat-icon>delete</mat-icon>
                              <span>Borrar</span>
                            </button>
                            &nbsp;
                            <button mat-raised-button style="background-color: var(--app-success); color: white;"
                              class="btn btn-principal" (click)="qualifyFood(foodFormArray.controls[i])">{{
                              foodFormArray.controls[i]['controls']['id'].value > 0 ? 'Actualizar' :
                              'Guardar'}}</button>
                          </div>
                        </div>
                        <table class="puntacion-table">
                          <tr>
                            <th>Elementos</th>
                            <th>Descripción</th>
                            <th>Calificación</th>
                          </tr>
                          <tr>
                            <td>Proteina</td>
                            <td style="padding-left: 10px;">{{ element.protein }}</td>
                            <td class="calificacion">
                              <div style="text-align: center;">
                                <input type="number" style="display: none;" id="protein{{ i }}" class="qualification"
                                  (change)="calcFood(foodFormArray.controls[i]['controls']['protein'], foodFormArray.controls[i])"
                                  formControlName="protein" step="0.5" max="1" min="0">

                                <div class="star-container">
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['protein'].value == 1">star</mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['protein'].value == 0.5">star_half
                                  </mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['protein'].value == 0 || foodFormArray.controls[i]['controls']['protein'].value == null">
                                    star_outline</mat-icon>

                                  <div>
                                    <button mat-mini-fab color="primary"
                                      (click)="increaseValue('protein', i, foodFormArray.controls[i]['controls']['protein'])">
                                      <mat-icon>expand_less</mat-icon>
                                    </button>
                                    <button mat-mini-fab color="primary"
                                      (click)="decrementValue('protein', i, foodFormArray.controls[i]['controls']['protein'])">
                                      <mat-icon>expand_more</mat-icon>
                                    </button>
                                  </div>
                                </div>

                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Grasas</td>
                            <td style="padding-left: 10px;">{{ element.fat }}</td>
                            <td class="calificacion">
                              <div style="text-align: center;">
                                <input type="number" style="display: none;" id="fat{{ i }}" class="qualification"
                                  (change)="calcFood(foodFormArray.controls[i]['controls']['fat'], foodFormArray.controls[i])"
                                  formControlName="fat" step="0.5" max="1.0" min="0">

                                <div class="star-container">
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['fat'].value == 1">star</mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['fat'].value == 0.5">star_half
                                  </mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['fat'].value == 0 || foodFormArray.controls[i]['controls']['fat'].value == null">
                                    star_outline</mat-icon>

                                  <div>
                                    <button mat-mini-fab color="primary"
                                      (click)="increaseValue('fat', i, foodFormArray.controls[i]['controls']['fat'])">
                                      <mat-icon>expand_less</mat-icon>
                                    </button>
                                    <button mat-mini-fab color="primary"
                                      (click)="decrementValue('fat', i, foodFormArray.controls[i]['controls']['fat'])">
                                      <mat-icon>expand_more</mat-icon>
                                    </button>
                                  </div>
                                </div>

                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Frutas - Vegetales</td>
                            <td style="padding-left: 10px;">{{ element.fruit_vegetable }}</td>
                            <td class="calificacion">
                              <div style="text-align: center;">
                                <input type="number" style="display: none;" id="fruit_vegetable{{ i }}"
                                  class="qualification"
                                  (change)="calcFood(foodFormArray.controls[i]['controls']['fruit_vegetable'], foodFormArray.controls[i])"
                                  formControlName="fruit_vegetable" step="0.5" max="1.0" min="0">

                                <div class="star-container">
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['fruit_vegetable'].value == 1">star
                                  </mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['fruit_vegetable'].value == 0.5">
                                    star_half</mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['fruit_vegetable'].value == 0 || foodFormArray.controls[i]['controls']['fruit_vegetable'].value == null">
                                    star_outline</mat-icon>

                                  <div>
                                    <button mat-mini-fab color="primary"
                                      (click)="increaseValue('fruit_vegetable', i, foodFormArray.controls[i]['controls']['fruit_vegetable'])">
                                      <mat-icon>expand_less</mat-icon>
                                    </button>
                                    <button mat-mini-fab color="primary"
                                      (click)="decrementValue('fruit_vegetable', i, foodFormArray.controls[i]['controls']['fruit_vegetable'])">
                                      <mat-icon>expand_more</mat-icon>
                                    </button>
                                  </div>
                                </div>

                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Almidón</td>
                            <td style="padding-left: 10px;">{{ element.starch }}</td>
                            <td class="calificacion">
                              <div style="text-align: center;">
                                <input type="number" style="display: none;" id="starch{{ i }}" class="qualification"
                                  (change)="calcFood(foodFormArray.controls[i]['controls']['starch'], foodFormArray.controls[i])"
                                  formControlName="starch" step="0.5" max="1.0" min="0">

                                <div class="star-container">
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['starch'].value == 1">star</mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['starch'].value == 0.5">star_half
                                  </mat-icon>
                                  <mat-icon class="star"
                                    *ngIf="foodFormArray.controls[i]['controls']['starch'].value == 0 || foodFormArray.controls[i]['controls']['starch'].value == null">
                                    star_outline</mat-icon>

                                  <div>
                                    <button mat-mini-fab color="primary"
                                      (click)="increaseValue('starch', i, foodFormArray.controls[i]['controls']['starch'])">
                                      <mat-icon>expand_less</mat-icon>
                                    </button>
                                    <button mat-mini-fab color="primary"
                                      (click)="decrementValue('starch', i, foodFormArray.controls[i]['controls']['starch'])">
                                      <mat-icon>expand_more</mat-icon>
                                    </button>
                                  </div>
                                </div>

                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" class="total">Total:</td>
                            <td class="calificacion">
                              <div style="text-align: center;">
                                <input type="text" class="total-input" formControlName="qualification" readonly>
                              </div>
                            </td>
                          </tr>
                        </table>
                        <hr>
                        <div class="row">
                          <div class="col-12">
                            <mat-form-field appearance="outline" style="color: black; font-size: 18px;">
                              <mat-label>Comentario</mat-label>
                              <textarea matInput rows="3" formControlName="comment">
                                </textarea>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <hr>
              </ng-container>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-container>

<ng-template #noInfo>
  <p>No hay información para mostrar</p>
</ng-template>

<!-- The Modal -->
<div id="myModal" class="modal">
  <span class="close">&times;</span>
  <img class="modal-content" id="img01">
  <div id="caption"></div>
</div>
